import { v4 as uuidv4 } from 'uuid'
import { VideoSelector } from './video-selector.js'

class BaseMediaEntry extends VideoSelector {
  constructor (videoSelectorData) {
    videoSelectorData.name = videoSelectorData.name || videoSelectorData.videoSelector
    super(videoSelectorData)
    this.videoSelector = videoSelectorData.videoSelector
    this.uuid = videoSelectorData.uuid || uuidv4()

    // TODO: Add logic to capture data for these two attributes
    this.watchedDuration = 0.0
    this.watchedSegments = []
    this.captions = videoSelectorData.captions || []
  }

  __commonTrigger (evt, user, data, eventAttrs) {
    return this.__triggerEvent(evt, {
      mediaEntry: this,
      user,
      data,
      eventAttrs
    })
  }
}

export default BaseMediaEntry
